/*
 *  About Template Scripts
 *    Scripts that are only meant to run on the About Template.
 *
 *  Version:
 *    1.0.0 - 2020/08/13
 * 
 * 
 */

/*
  AboutTemplate

  Syncs the displayed image in the left column of the about page with the 
  right column slide on scroll

  markup:
  data-about-container
    data-about-images
      data-about-images__slide.is-active
      data-about-images__slide
      data-about-images__slide
      ...

    data-about-slides
      data-about-slides__slide.is-active
      data-about-slides__slide
      data-about-slides__slide
      ...
*/

// Selectors
export const ABOUT_CONTAINER      = '[data-about-container]';
export const ABOUT_IMAGES         = '[data-about__images]';
export const ABOUT_IMAGES_SLIDES  = '[data-about__images__slide]';
export const ABOUT_SLIDES         = '[data-about__slides]';
export const ABOUT_SLIDES_SLIDES  = '[data-about__slides__slide]';

// Classes
export const ACTIVE_CLASS         = 'is-active';

// Variables
export const scrollPastOffset     = 300;
export let currentScrollPos       = 0;
export let currentActive          = 0;

class AboutTemplate {
  constructor(container) {
    // Elements
    this.container = container;
    this.imageSlides = container.querySelectorAll(ABOUT_IMAGES_SLIDES);
    this.textSlides = container.querySelectorAll(ABOUT_SLIDES_SLIDES);
    this.textSlidePositions = [];

    // init
    this.initAboutTemplate();

    // Events
    $(window).on('scroll', () => this.aboutOnScroll());
    $(window).on('resize', () => this.initAboutTemplate());
  }

  initAboutTemplate() {
    // apply is-animation-ready class slightly after to prevent loading jank
    this.container.classList.add('is-animation-ready');
    // Update the array of top pixel measurements
    for(let i=0; i<this.textSlides.length; i++) {
      this.textSlidePositions[i] = window.scrollY + this.textSlides[i].getBoundingClientRect().y;
    }
    // console.log(this.textSlidePositions);
  }

  aboutOnScroll() {
    // find out which is the current slide
    currentScrollPos = window.scrollY;
    let lastIndexScrolledPast = 0;
    // console.log(`${currentScrollPos + scrollPastOffset}`);
    for(let i=0; i<this.textSlidePositions.length; i++) {
      if((currentScrollPos + scrollPastOffset )> this.textSlidePositions[i]) {
        lastIndexScrolledPast = i;
      }
    }
    if (lastIndexScrolledPast !== currentActive) {
      // console.log(`changing to slide ${lastIndexScrolledPast}`);
      this.imageSlides[currentActive].classList.remove('is-active');
      this.imageSlides[lastIndexScrolledPast].classList.add('is-active');
      currentActive = lastIndexScrolledPast;
    }
  }

}

document.addEventListener("DOMContentLoaded", function() {
  let instances = document.querySelectorAll(ABOUT_CONTAINER);
  for(let i=0; i<instances.length; i++) {
    new AboutTemplate(instances[i]);
  }
});